/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for HProductController controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { Pageable, RequestOptions, PagedModelHousingProduct, HProductDTO, PagedModelHProductDTO } from "../models";

@Injectable({ providedIn: "root" })
export class HProductControllerService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    getProducts(pageable: Pageable, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelHousingProduct>;
    getProducts(pageable: Pageable, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelHousingProduct>>;
    getProducts(pageable: Pageable, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelHousingProduct>>;
    getProducts(pageable: Pageable, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/housing/products`;

        let params = new HttpParams();
        if (pageable != null) {
            params = HttpParamsBuilder.addToHttpParams(params, pageable, 'pageable');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addProduct(hProductDTO: HProductDTO, observe?: 'body', options?: RequestOptions<'json'>): Observable<HProductDTO>;
    addProduct(hProductDTO: HProductDTO, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<HProductDTO>>;
    addProduct(hProductDTO: HProductDTO, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<HProductDTO>>;
    addProduct(hProductDTO: HProductDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/housing/products`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: hProductDTO,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getProductsByPromoter(promoterId: number, pageable: Pageable, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelHProductDTO>;
    getProductsByPromoter(promoterId: number, pageable: Pageable, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelHProductDTO>>;
    getProductsByPromoter(promoterId: number, pageable: Pageable, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelHProductDTO>>;
    getProductsByPromoter(promoterId: number, pageable: Pageable, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/housing/products/promoter/${promoterId}`;

        let params = new HttpParams();
        if (pageable != null) {
            params = HttpParamsBuilder.addToHttpParams(params, pageable, 'pageable');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
